module.exports = __webpack_public_path__ + "img/explore_02.c98cd5c0.jpg";